class SurveyModal extends HTMLElement {
  constructor() {
    super();
    this.popupPanel = this.closest('popup-panel');
    this.backdrop = this.popupPanel.parentNode.querySelector('.popup-panel-backdrop');
    this.threshold = parseInt(this.dataset.threshold, 10) || 2;

    this.markShown = this.markShown.bind(this);

    this.initCookies();
    this.bindCloseHandlers();
  }

  initCookies() {
    const stored = this.getCookie('survey_visits');

    if (stored === 'shown') return;

    const previousVisits = parseInt(stored, 10) || 0;
    const currentVisit = previousVisits + 1;

    if (currentVisit >= this.threshold) {
      this.popupPanel.show();
      this.setCookie('survey_visits', 'shown', 365);
    } else {
      this.setCookie('survey_visits', currentVisit, 365);
    }
  }

  markShown() {
    this.setCookie('survey_visits', 'shown', 365);
  }

  bindCloseHandlers() {
    this.querySelector('[close]').addEventListener('click', this.markShown);
    this.backdrop.addEventListener('click', this.markShown);
    this.addEventListener('custom:escape', this.markShown);

    const cta = this.querySelector('[data-cta]');
    if (cta) {
      cta.addEventListener('click', this.markShown);
    }
  }

  getCookie(name) {
    const cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      const cookiePair = cookieArray[i].split('=');
      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  }
}

customElements.define('survey-modal', SurveyModal);
